import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { captureAttribution, trackStep } from '../lib/attribution';

const PRIVATE_PATHS = /^\/(admin|dashboard|formateur|programme|success)/;
const SCROLL_STEPS = [[25, 'scroll_25'], [50, 'scroll_50'], [75, 'scroll_75']];

/** Mémorise la pub d'arrivée et les étapes de la page, une fois par session. */
export default function FunnelTracker() {
  const location = useLocation();

  useEffect(() => {
    if (PRIVATE_PATHS.test(location.pathname)) return undefined;
    try {
      if (localStorage.getItem('openbro_visit_mute') === '1' || localStorage.getItem('token')) return undefined;
    } catch {
      return undefined;
    }
    captureAttribution();
    if (!sessionStorage.getItem('openbro_funnel_landing')) {
      sessionStorage.setItem('openbro_funnel_landing', '1');
      trackStep('landing');
    }
    const sent = new Set();
    const onScroll = () => {
      const height = document.documentElement.scrollHeight - window.innerHeight;
      if (height <= 0) return;
      const pct = (window.scrollY / height) * 100;
      SCROLL_STEPS.forEach(([mark, step]) => {
        if (pct < mark || sent.has(step)) return;
        sent.add(step);
        trackStep(step);
      });
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [location.pathname]);

  return null;
}
